<section class="bg-white py-16 md:py-20 px-5 md:px-10">
  <div class="max-w-7xl mx-auto">
    <div class="text-center mb-12 animate-fadeInUp">
      <h1 class="text-primary text-3xl md:text-5xl font-bold mb-4">
        ¿Por qué elegir <span class="text-primary">everfull?</span>
      </h1>
      <div
        class="h-0.5 bg-gradient-to-r from-primary to-secondary rounded-full mx-auto mb-6 inline-block"
      ></div>
      <p class="text-gray-700 text-lg max-w-3xl mx-auto">
        Descubrí los beneficios que hacen la diferencia en tu día a día
      </p>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
      <!-- Cómodo -->
      <div
        class="bg-white rounded-2xl p-8 shadow-soft hover:shadow-strong transition-all duration-300 hover:-translate-y-2 text-center group animate-fadeInUp"
        style="animation-delay: 0.1s"
      >
        <div class="mb-6 flex justify-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
          >
            <img
              src="./assets/gota_icono.png"
              class="w-16 h-16 object-contain"
              alt="Cómodo"
            />
          </div>
        </div>
        <h3 class="text-primary font-bold text-2xl mb-4">Cómodo</h3>
        <p class="text-gray-700 leading-relaxed">
          Contá con <strong class="text-primary">agua purificada</strong> fría y
          caliente en el momento sin la necesidad de comprar botellas o reponer
          botellones.
        </p>
        <div class="mt-6 pt-6 border-t border-gray-200">
          <span
            class="inline-flex items-center text-secondary font-semibold text-sm"
          >
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            Siempre disponible
          </span>
        </div>
      </div>

      <!-- Cuidás tu salud -->
      <div
        class="bg-white rounded-2xl p-8 shadow-soft hover:shadow-strong transition-all duration-300 hover:-translate-y-2 text-center group animate-fadeInUp"
        style="animation-delay: 0.2s"
      >
        <div class="mb-6 flex justify-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-secondary/10 to-primary/10 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
          >
            <img
              src="./assets/salud_icono.png"
              class="w-16 h-16 object-contain"
              alt="Salud"
            />
          </div>
        </div>
        <h3 class="text-primary font-bold text-2xl mb-4">Cuidás tu salud</h3>
        <p class="text-gray-700 leading-relaxed">
          Contá con la tranquilidad de nuestra
          <strong class="text-primary"
            >purificación certificada por ANMAT</strong
          >. Hidratate, cocina y lava tus alimentos con el mejor agua.
        </p>
        <div class="mt-6 pt-6 border-t border-gray-200">
          <span
            class="inline-flex items-center text-secondary font-semibold text-sm"
          >
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            Certificado ANMAT
          </span>
        </div>
      </div>

      <!-- Eco-Friendly -->
      <div
        class="bg-white rounded-2xl p-8 shadow-soft hover:shadow-strong transition-all duration-300 hover:-translate-y-2 text-center group animate-fadeInUp"
        style="animation-delay: 0.3s"
      >
        <div class="mb-6 flex justify-center">
          <div
            class="w-24 h-24 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300"
          >
            <img
              src="./assets/ecofriendly_icono.png"
              class="w-16 h-16 object-contain"
              alt="Eco-Friendly"
            />
          </div>
        </div>
        <h3 class="text-primary font-bold text-2xl mb-4">Eco-Friendly</h3>
        <p class="text-gray-700 leading-relaxed">
          <strong class="text-primary">Eliminá el residuo de botellas</strong>
          de plástico de un solo uso y las emisiones de CO2 generadas en las
          entregas frecuentes gracias a nuestro servicio.
        </p>
        <div class="mt-6 pt-6 border-t border-gray-200">
          <span
            class="inline-flex items-center text-secondary font-semibold text-sm"
          >
            <svg class="w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              />
            </svg>
            Cuidamos el planeta
          </span>
        </div>
      </div>
    </div>

    <!-- Call to action -->
    <div
      class="mt-12 text-center animate-fadeInUp"
      style="animation-delay: 0.4s"
    >
      <div
        class="inline-flex items-center bg-gradient-to-r from-primary to-blue-900 text-white rounded-full px-8 py-4 shadow-medium"
      >
        <svg class="w-6 h-6 mr-3" fill="currentColor" viewBox="0 0 20 20">
          <path
            d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"
          />
        </svg>
        <span class="font-bold text-lg">
          Más de 30 años brindando agua de la mejor calidad
        </span>
      </div>
    </div>
  </div>
</section>
